// extracted by mini-css-extract-plugin
export default {"list":"TimelineBlock_list__t2jMX","line":"TimelineBlock_line__fgtAR","number":"TimelineBlock_number__wzZnT","text":"TimelineBlock_text__XIQxi"};